<template>
  <div class="chat-body">
    <div class="search-wrap">
      <el-select size="mini" v-model="groupType" placeholder="选择群类型" clearable style="width: 120px;">
        <el-option v-for="item in groupTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px" @clear="clearKeyword"></el-input>
      <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
    </div>

    <div class="table-wrap-c">
      <el-table :height="__TABLE_HEIGHT__" v-loading="loading" default-expand-all class="chat-table" :data="tableData" row-key="id">
        <el-table-column prop="name" label="群名"></el-table-column>
        <el-table-column prop="member_name" label="群主" align="center" width="150"></el-table-column>
        <el-table-column label="项目" width="250" align="center">
          <template slot-scope="scope" align="center">
            <el-tag v-if="scope.row.house_name">{{ scope.row.house_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150" align="center"></el-table-column>
        <el-table-column prop="notice" label="公告">
          <template slot-scope="scope">
            <el-popover width="500" placement="top-start" title="内容" trigger="click" :content="scope.row.notice">
              <span slot="reference" v-html="shortText(scope.row.notice)"></span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="admin_list" label="管理员"></el-table-column>
        <el-table-column prop="status" label="跟进状态"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" round @click="showMemberList(scope.row.chat_id)">查看成员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="prev, pager, next, total" :total="total" :current-page="page" :page-size="pageSize" @current-change="currentChange"></el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" width="1000px">
        <el-table :height="__TABLE_HEIGHT__" v-loading="memberLoading" :data="memberList" width>
          <el-table-column label="类型" width="110">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.type == 1 ? 'primary' : 'info'">{{ typeList[scope.row.type] }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column property="name" label="姓名" width="100"></el-table-column>
          <el-table-column property="group_nickname" label="群昵称" width="100"></el-table-column>
          <el-table-column property="join_time" label="入群时间" width="200"></el-table-column>
          <el-table-column property="join_scene" label="入群方式" width=""></el-table-column>
          <el-table-column property="invitor" label="邀请者" width="200"></el-table-column>
        </el-table>
      </el-dialog>

    </div>

  </div>
</template>

<script>

export default {
  name: "ConversationGroupChat",
  data () {
    return {
      keyword: '',
      page: 1,
      total: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      statusList: {
        0: "跟进人正常",
        1: "跟进人离职",
        2: "离职继承中",
        3: "离职继承完成"
      },
      dialogTitle: '',
      dialogTableVisible: false,
      memberList: [],
      memberLoading: false,
      typeList: {
        1: "企业成员",
        2: "外部联系人"
      },
      joinScineList: {
        1: "由群成员邀请入群（直接邀请入群）",
        2: "由群成员邀请入群（通过邀请链接入群）",
        3: "通过扫描群二维码入群"
      },
      groupType: 1,
      groupTypeList: [
        { label: '已监管', value: 1 },
        { label: '未监管', value: 0 }
      ]
    }
  },
  created() {
    this.getGroupList()
  },
  watch: {
      '$route': function() {
        if(this.$route.path == '/Conversation/GroupChat') {
          this.keyword = this.$route.query.chatId || ''
          this.getGroupList()
        }
      }
    },
  computed:{
    __TABLE_HEIGHT__(){
      return (window.outerHeight - 350) + 'px'
    }
  },
  methods: {
    search() {
      this.page = 1
      this.getGroupList()
    },
    getGroupList() {
      const that = this
      that.loading = true
      that.$qwhttp.get('group/list', {params: { group_type: this.groupType, keyword: this.keyword, page: this.page, page_size: this.pageSize }}).then( res => {
        if(res.status == 200) {
          if(res.data.total > 0) {
            that.tableData = res.data.data.map(item => {
              if(item.name == "") item.name = "[群聊]"
              item.create_time = that.dateFormat(item.create_time)
              item.status = that.getStatusName(item.status)
              //if(item.department) item.department = item.department.map(item => item.reverse().join(' - '))
              return item
            })
          } else {
            that.tableData = []
          }
          that.total = res.data.total
        }
        that.loading = false
      });
    },
    currentChange(page) {
      this.page = page
      this.getGroupList()
    },
    dateFormat(timestamp = 0, displayTime = true) {
    	let date = timestamp > 0 ? new Date(timestamp * 1000) : new Date();
    	let year = date.getFullYear();
    	let month = ("0" + (date.getMonth() + 1)).slice(-2);
    	let sdate = ("0" + date.getDate()).slice(-2);
    	let hour = ("0" + date.getHours()).slice(-2);
    	let minute = ("0" + date.getMinutes()).slice(-2);
    	let second = ("0" + date.getSeconds()).slice(-2);
    	let result = year + "-" + month + "-" + sdate;
    	if(displayTime) result += " " + hour + ":" + minute + ":" + second
    	return result
    },
    getStatusName(status) {
      return this.statusList[status]
    },
    showMemberList(chat_id) {
      const that = this
      that.dialogTableVisible = true
      that.memberLoading = true
      that.$qwhttp.get('group/members', {params: {chat_id: chat_id}}).then( res => {
        if(res.status == 200) {
          if(res.data.data != null ) {
            res.data.data.map(item => {
              item.join_time = that.dateFormat(item.join_time)
              item.join_scene = that.joinScineList[item.join_scene]
              return item
            })
          }
          this.dialogTitle = '成员列表('+ (res.data.data ? res.data.data.length : 0) +')'
          that.memberList = res.data.data
        }
        that.memberLoading = false
      });

    },
    clearKeyword(a) {
      console.log(a)
    },
    shortText(text) {
      let newText = text.length > 50 ? '<a href="javascript:;">' + text.substr(0, 50) + '...</a>' : text
      return newText
    },
  }
}
</script>
<style scoped>
  .text2,.el-button--primary {
    color: #FFFFFF;
  }
  .add-type {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
  }
  .search-wrap {
    padding-bottom: 15px;
    border-bottom: 1px solid #EBEEF5;
  }
  .chat-body {
    position: relative;
    padding: 15px;
  }
  .pagination {
    display: flex;
    padding: 15px 0;
    justify-content: center;
  }
  .tag-department {
    margin: 1px 1px 1px 0;
    height: auto;
    white-space: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/GroupChat.vue